import { render, staticRenderFns } from "./groupsView.vue?vue&type=template&id=211c77eb&scoped=true&"
import script from "./groupsView.vue?vue&type=script&lang=js&"
export * from "./groupsView.vue?vue&type=script&lang=js&"
import style0 from "./groupsView.vue?vue&type=style&index=0&id=211c77eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c77eb",
  null
  
)

export default component.exports